import { Cluster, Icon, IconName, SpotlightItem, Stack, Typography } from '@forto-dev/phoenix-ui-core'

import { useLocalisation } from '@/utils/localisation'

type SearchlightResultItemLayoutProps = {
  value: string
  prefix?: string
  searchContent: string
  iconName: IconName
  shipmentID?: string
  bookingID?: string
  onSelect: () => void
}

export const SearchlightResultItemLayout = ({
  onSelect,
  value,
  iconName = 'Document',
  prefix,
  searchContent,
  shipmentID,
  bookingID,
}: SearchlightResultItemLayoutProps) => {
  const { translate } = useLocalisation()
  return (
    <SpotlightItem value={value + `${shipmentID ? shipmentID : bookingID}`} onSelect={onSelect}>
      <Cluster gap={8} y="center">
        <Icon color="muted" name={iconName} size="md" />
        <Stack>
          <Cluster gap={8} y="center">
            {prefix && <Typography color="muted">{`${prefix}:`}</Typography>}
            <Typography variant="body-bold">{searchContent}</Typography>
          </Cluster>
          {shipmentID && <Typography color="muted">{`${translate('search.shipmentID')}: ${shipmentID}`}</Typography>}
          {bookingID && !shipmentID && (
            <Typography color="muted">{`${translate('search.bookingID')}: ${bookingID}`}</Typography>
          )}
        </Stack>
      </Cluster>
    </SpotlightItem>
  )
}
